import React, { Component } from 'react'
import firebase from 'firebase'
import {Helmet} from "react-helmet";
import { Twitter } from 'react-social-sharing'
const questions = [
  {
    title: 'what do you describe yourself as',
    options: [ 'title1', 'title2', 'title3', 'title4']
  },
  {
    title: 'click features you are interested in',
    options: [ 'feature1', 'feature2', 'feature3', 'feature4']
  }
]

class WailitngList extends Component {
  state = {
    selectedOptions: {},
    data: []
  }

  componentDidMount() {
    firebase.database().ref('List').once('value')
    .then(snap => {
      const users = snap.val()

      const data = Object.keys(users).map(key => ({uid: key, value: users[key]}))

      this.setState({data})
    })
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.loaded && !nextProps.user) {
      this.props.history.push('/signup')
    }
  }

  handleClick = (question, option) => {
    const { selectedOptions } = this.state

    const currentAnswers = selectedOptions[question]

    if (!currentAnswers) {
      this.setState({
        selectedOptions: {
          ...selectedOptions,
          [question]: [option]
        }
      })
    } else {
      const index = currentAnswers.findIndex(opt => opt === option)

      if (index === -1) {
        this.setState({
          selectedOptions: {
            ...selectedOptions,
            [question]: [
              ...currentAnswers,
              option
            ]
          }
        })
      } else {
        this.setState({
          selectedOptions: {
            ...selectedOptions,
            [question]: [
              ...currentAnswers.slice(0, index),
              ...currentAnswers.slice(index + 1)
            ]
          }
        })
      }
    }
  }

  render() {
    const { selectedOptions, data } = this.state
    const { user, username } = this.props

    let number = null

    if (data.length && user) {
      number = data.sort((a, b) => a.value - b.value).findIndex(e => e.uid === user.uid) + 1
    }

    return (
      <div>
  <Helmet   titleTemplate="just.is - %s">
            <title>wait list</title>
            <meta name="description" content="Nested component" />
        </Helmet>
          <div class="form">

<div class="header">



<br/>
<h1>@{username}</h1>
<button class="google" onClick={() => this.props.history.push('/username')}><h3>Change username</h3></button>
<br/>
  <div class="sign-in-container ">

   tweet this shit! <img src="https://icon.now.sh/arrow"/> <Twitter simple message={'Im # ' + number + ' on the just.is waitlist.' || '...' } /> 
   
  </div>

</div>

<div class="sign-in-form wait">
<h1> You are<br /><b>#{number || '...'}</b>  on the waitlist</h1>

<br/>

<button class="google small bold" onClick={() => {
  firebase.auth().signOut()
  .then(() => this.props.history.push('/'))
  
  }}>reserve or change another username </button>

  <div class="sign-up-container">
  </div>

</div>

</div>  
          </div>
    )
  }
}

export default WailitngList



// WEBPACK FOOTER //
// ./src/routes/WailitngList.js